import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { TranslatorConverter } from "src/TranslatorConverter";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { Enum, IEnumTranslator } from "uicomponents";
import { InvoicesListViewModel } from "../invoicesList/invoicesList-viewModel";
import  { ReturnInvoiceRequestFormView } from "./returnInvoiceRequestForm-view"

export class ReturnInvoiceRequestFormViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: InvoicesListViewModel, id) {
        super(parentViewModel);
        this.loadById(id);
        this._typedParent = parentViewModel;
        this.lineItems = ObservableArray.create<InvoiceLineItem>();
    }
    GetDefaultView(): View <ViewModel> {
        return new ReturnInvoiceRequestFormView();
    }
    public getTypeId(): string {
        return "VM-BCAA24D9-EA02-4E0F-B6AE-1C1CD2D38B93"
    }

    private _typedParent : InvoicesListViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName; } private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set sellerName(v: string) { this._sellerName = v; } public get sellerName(): string { return this._sellerName; } private _sellerName: string;
    public set invoiceNumber(v: string) { this._invoiceNumber = v; } public get invoiceNumber(): string { return this._invoiceNumber; } private _invoiceNumber: string;
    public set parentInvoiceNumber(v: string) { this._parentInvoiceNumber = v; } public get parentInvoiceNumber(): string { return this._parentInvoiceNumber; } private _parentInvoiceNumber: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName; } private _districtName: string;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalDeficit(v: number) { this._totalDeficit = v; } public get totalDeficit(): number { return this._totalDeficit; } private _totalDeficit: number;
    public set totalAmount(v: number) { this._totalAmount = v; } public get totalAmount(): number { return this._totalAmount;} private _totalAmount: number;
    public set totalAdditions(v: number) { this._totalAdditions = v; } public get totalAdditions(): number { return this._totalAdditions; } private _totalAdditions: number;
    public set creationTime(v: moment.Moment) { this._creationTime = v; } public get creationTime(): moment.Moment { return this._creationTime; } private _creationTime: moment.Moment;
    public set state(v: number) { this._state = v; } public get state(): number { return this._state; } private _state: number;
    public set lineItems(v: ObservableArray<InvoiceLineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<InvoiceLineItem> { return this._lineItems; } private _lineItems: ObservableArray<InvoiceLineItem>;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async loadById(invoiceId: string) {
        let result = await ServerConnection.callServer('Complex/SellServices/GetInvoiceDetail', {
            InvoiceId: invoiceId,
        });
        this.id = result.Id;
        this.customerName = result.CustomerName;
        this.customerCode = result.CustomerCode;
        this.invoiceNumber = result.InvoiceNumber;
        this.totalDeficit = 0;
        this.totalAdditions = 0;
        this.lineItems.update(...result.LineItems.map((q, i) => {
            let r = new InvoiceLineItem(this);
            r.rowNumber = i + 1;
            r.deliveryWarehouseId = q.DeliveryWarehouseId;
            r.deliveryWarehouseName = q.DeliveryWarehouseName;
            r.saleFromWarehouseId = q.SaleFromWarehouseId;
            r.saleFromWarehouseName = q.SaleFromWarehouseName;
            r.id = q.MeasuredProductId;
            r.productName = q.ProductName;
            r.productCode = q.ProductCode;
            r.productCarModel = q.ProductCarModel;
            r.feePrice = q.FeePrice;
            r.amount = q.Amount;
            r.count = 0;
            r.totalPrice = 0;
            r.deficit = q.DeficitPrice;
            r.showDeficit = 0;
            r.finalPrice = 0;
            r.additionalPrice = q.AdditionalPrice;
            return r;
        }));
        this.totalPrice = 0;
        this.totalAmount = 0;
        this.finalPrice = 0;
        this.calculatePrice();
    }

    back() {

    }
    
    async createReturnInvoice() {
        try {
            let verificationResult =  this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست مرجوعی');
                return;
            }
            let r:string; 
            r = await this.messageBoxWarningYesNo('آیا درخواست فاکتور مرجوعی ساخته شود؟','درخواست فاکتور مرجوعی');
            if(r=='no'){
                return;
            }
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/SellServices/CreateReturnInvoiceRequest', {
                InvoiceId: this.id,
                LineItems: this.lineItems.filter(q => q.count > 0).map(q => {
                    return {
                        MeasuredProductId: q.id,
                        Amount: q.count,
                        FeePrice: q.feePrice,
                        DeficitPrice: q.showDeficit,
                        TotalPrice: q.totalPrice,
                        FinalPrice: q.finalPrice,
                        AdditionalPrice: q.additionalPrice,
                        DeliveryWarehouseId: q.deliveryWarehouseId,
                        DeliveryWarehouseName: q.deliveryWarehouseName,
                        SaleFromWarehouseId: q.saleFromWarehouseId,
                        SaleFromWarehouseName: q.saleFromWarehouseName,
                        Reason: q.getReasonId()
                    }
                })
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess(`درخواست فاکتور مرجوعی با موفقیت ثبت شد.`, 'عملیات موفق');
            } else {
                if (result.Faults[0].Parameters.FaultId === "58E34570-AD7A-460B-B951-607F26AF8AFB") {
                    throw "این فاکتور قابل مرجوعی نیست.";    
                } else {
                    throw "خطا در ثبت فاکتور";
                }
            }
            this.closePopup();
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
            this._typedParent.refresh();
        }
    }
   
    private _calculatePriceTimer : any;
    async requestCalculatePrice() {
        if(this._calculatePriceTimer!=null){
            clearTimeout(this._calculatePriceTimer);
        }
        this._calculatePriceTimer = setTimeout(() => {
            this.calculatePrice();
        }, 500);
    }

    private async calculatePrice(){
        try {
            if (this.lineItems.length == 0){
                this.totalPrice = 0;
                this.totalAdditions = 0;
                this.totalDeficit = 0;
                this.finalPrice = 0;
                this.totalAmount = 0;
            }else{
                this.isLoading = true;
                this.lineItems.forEach(x=>{
                    x.totalPrice = x.feePrice * x.count;
                    x.finalPrice = x.totalPrice + x.additionalPrice - x.showDeficit;
                })

                this.totalPrice = this.lineItems.reduce((a,c)=>a+c.totalPrice,0);
                this.finalPrice = this.lineItems.reduce((a,c)=>a+c.finalPrice,0);
                this.totalDeficit = this.lineItems.reduce((a,c)=>a+c.showDeficit,0);
                this.totalAdditions = this.lineItems.reduce((a,c)=>a+c.additionalPrice,0);
                this.totalAmount = this.lineItems.reduce((a,c)=>a+c.count,0);
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    
    verify():string[]{
        let faults :string[] =[];
        let amountsWithInvalidAmounts = this.lineItems.filter(x=>x.count<0);
        if(amountsWithInvalidAmounts.length>0){
            faults.push(`${amountsWithInvalidAmounts.length==1 ? 'سطر' : 'سطرهای'} ${amountsWithInvalidAmounts.map(x=>x.rowNumber).join(' و ')} دارای میزان منفی است.`);
        }
        let exessiveAmounts = this.lineItems.filter(x=>x.count>x.amount);
        if(exessiveAmounts.length>0){
           faults.push(`${exessiveAmounts.length==1 ? 'سطر' : 'سطرهای'} ${exessiveAmounts.map(x=>x.rowNumber).join(' و ')} دارای مقداری بیش از فاکتور است.`);
        }
        let reasons = this.lineItems.filter(x=> x.count > 0 && undefined == x.getReasonId());
        if(reasons.length>0){
           faults.push(`${reasons.length==1 ? 'سطر' : 'سطرهای'} ${reasons.map(x=>x.rowNumber).join(' و ')} علتش مشخص نشده.`);
        }
        if(this.lineItems.every(x => x.count == 0)){
           faults.push(`تعداد همه سطرها نمی تواند صفر باشد.`);
        }
        return faults;
    }
    
    closePopup() {

    }
}
export class InvoiceLineItem extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ReturnInvoiceRequestFormViewModel) {
        super(parent);
        this._typedParent = parent;
        this.reasonSelector = new ReasonTypeSelectorViewModel(this);
    }
    private _typedParent : ReturnInvoiceRequestFormViewModel;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber; } private _rowNumber: number;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode; } private _productCode: string;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName; } private _productName: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set saleFromWarehouseId(v: string) { this._saleFromWarehouseId = v; } public get saleFromWarehouseId(): string { return this._saleFromWarehouseId; } private _saleFromWarehouseId: string;
    public set saleFromWarehouseName(v: string) { this._saleFromWarehouseName = v; } public get saleFromWarehouseName(): string { return this._saleFromWarehouseName; } private _saleFromWarehouseName: string;
    public set deliveryWarehouseId(v: string) { this._deliveryWarehouseId = v; } public get deliveryWarehouseId(): string { return this._deliveryWarehouseId; } private _deliveryWarehouseId: string;
    public set deliveryWarehouseName(v: string) { this._deliveryWarehouseName = v; } public get deliveryWarehouseName(): string { return this._deliveryWarehouseName; } private _deliveryWarehouseName: string;
    public set amount(v: number) { this._amount = v; } public get amount(): number { return this._amount; } private _amount: number;
    public set count(v: number) { 
        this._count = getAsNumber(v,true); 
        this.showDeficit = this._count > 0 ? Math.floor(this.deficit * this._count / this.amount) : 0;
        this.requestRecalculation();
    } public get count(): number { return this._count;} private _count: number;
    public set feePrice(v: number) { this._feePrice = v; } public get feePrice(): number { return this._feePrice; } private _feePrice: number;
    public set deficit(v: number) { this._deficit = v; } public get deficit(): number { return this._deficit; } private _deficit: number;
    public set finalPrice(v: number) { this._finalPrice = v; } public get finalPrice(): number { return this._finalPrice; } private _finalPrice: number;
    public set totalPrice(v: number) { this._totalPrice = v; } public get totalPrice(): number { return this._totalPrice; } private _totalPrice: number;
    public set additionalPrice(v: number) { this._additionalPrice = v; } public get additionalPrice(): number { return this._additionalPrice; } private _additionalPrice: number;
    public set showDeficit(v: number) { this._showDeficit = v; } public get showDeficit(): number { return this._showDeficit;} private _showDeficit: number;
    public set unitName(v: string) { this._unitName = v; } public get unitName(): string { return this._unitName; } private _unitName: string;
    public set reasonSelector(v: ReasonTypeSelectorViewModel) { this._reasonSelector = v; } public get reasonSelector(): ReasonTypeSelectorViewModel { return this._reasonSelector;} private _reasonSelector: ReasonTypeSelectorViewModel;
    
    private requestRecalculation(){
        this._typedParent.requestCalculatePrice();
    }
    setReasonId(id: string, name: string) {
        this.reasonSelector.selectById(id);
    }

    getReasonId() {
        return this.reasonSelector.selectedItem?.id;
    }
    
}

export class ReasonTypeSelectorViewModel extends SelectorBaseViewModel<CommentPattern>{
    protected async loadData(): Promise<CommentPattern[]> {
        let result = await ServerConnection.callServer('/Complex/SellServices/GetAllReturnInvoiceCommentPattern',{});
        return result.ReturnInvoiceCommentPatterns.map(q=>{
            let result = new CommentPattern(this);
            result.id = q.CommentPatternId;
            result.title = q.CommentPatternText;
            return result;
        });
    }

}

export class CommentPattern extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}

export class ReasonTypeEnumProvider extends Enum implements IEnumTranslator{
    constructor() {
        super();
        this.values = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25];
        this.translator = this;
        this.converter = new TranslatorConverter(); 
    }
    private converter:TranslatorConverter;
    GetString(value: any) {
        return this.converter.translateReturnInvoiceReasonType(value);
    }
}